const globalFn = () => { };

const globalScripts = globalFn;

export { globalScripts as g };

//# sourceMappingURL=app-globals-05a7fd2f.js.map